// ** Redux Imports
import { createSlice } from '@reduxjs/toolkit'

export const advanceShipNoticeItemAddSlice = createSlice({
  name: 'advanceShipNoticeItemAdd',
  initialState: {
    selectedItems: []
  },
  reducers: {
    addAdvanceShipItem: (state, action) => {
      state.selectedItems = action.payload
    },
    clearAdvanceShipItem: (state, action) => {
      state.selectedItems = action.payload
    }
  }
})

export const { addAdvanceShipItem, clearAdvanceShipItem } = advanceShipNoticeItemAddSlice.actions

export default advanceShipNoticeItemAddSlice.reducer
